import * as React from "react";
import { FilterLiveSearch, useTranslate } from 'react-admin';

export default (props) => {
    const t = useTranslate();

    return (
        <FilterLiveSearch source="gradeId" label={t('components.list_filters.gradeId', { _: "Grade ID" })} />
    )
};